// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Combos_CancelarCompraInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de POST /so/combos/cancelar_compra (NS 2026-0090, fatia 5).
 *
 * Cancela uma compra de combo: anula o saldo restante (um `cancelamento`
 * com os pares disponiveis) e a compra vai a `cancelada`. A devolucao em
 * dinheiro e calculada fora do sistema. Compra com par reservado numa OS
 * recusa (desvincule antes). Full/Franqueado/Gerente.
 *
 * JSON body:
 * {
 *   "purchase_id": 12,                       // so_combo_purchases PK, required
 *   "motivo": "Cliente desistiu do combo"    // required, nao vazio
 * }
 */
import { registerContract } from './validate'

export interface Combos_CancelarCompraInput {
purchase_id: number
motivo: string
}

registerContract('Combos_CancelarCompraInput', {
  purchase_id: { type: 'number',  required: true },
  motivo:      { type: 'string',  required: true },
})
